<template>
  <slot name="form" :content="form" :errors="errors" :loading="loading" :submit="submitForm"/>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import utilities from "../../utilities.js";
import axios from "axios";
import {toasts} from "../../../index";

const props = defineProps({
  endpoint: String,
  content: Object,
  method: String
});

const emit = defineEmits(["success", "error", "update:content"]);

const form = ref({});
const errors = ref({});
const loading = ref(false);
const lastContent = ref(undefined);

onMounted(() => {
  if (props.content) {
    form.value = JSON.parse(JSON.stringify(props.content));
  } else {
    form.value = {};
  }
  lastContent.value = JSON.stringify(props.content);
});

watch(() => props.content, value => {
  if (value === lastContent.value) return;
  if (JSON.stringify(value) === lastContent.value) return;
  lastContent.value = value ? JSON.stringify(value) : undefined;
  form.value = lastContent.value ? JSON.parse(lastContent.value) : {};
}, {
  immediate: true,
  deep: true
});

watch(form, () => {
  emit("update:content", form.value);
}, {
  deep: true
});

function submitForm() {
  loading.value = true;
  axios.request({
    url: props.endpoint,
    method: props.method,
    data: form.value,
    headers: {
      "Content-Type": "application/json"
    }
  }).then((response) => {
    // this.form = {};
    errors.value = {};
    emit("success", response.data);
  }).catch((error) => {
    if (error?.response?.status === 422) {
      errors.value = utilities.decodeValidationErrors(error.response?.data?.errors ? error.response.data.errors : {});
    } else {
      toasts.create({
        color: "danger",
        content: error?.response?.data?.message ? error.response.data.message : error.message
      });
    }
    emit("error", error);
  }).finally(() => {
    loading.value = false;
  });
}
</script>